/**
 * This file is used to aggregate all the css files that are used by our components.  This is necessary because with webpack chunks,
 * extract text is unable to create a style sheet for individual chunks.  To get around this, we load all the chunked styles
 * here.
 */
import '../../styles/app.sass';

import './social/social.sass';
import './copyright/copyright.sass';
import './legal/legal.sass';
import './button/upbutton.sass';
import './button/callToAction.sass';
import './links/footerlinks.sass';
import './newsLetter/newsLetter.sass';
